import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, X } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const BENEFITS = [
  "Veteriner, nakliyeci ve kasap iletişim bilgilerine sınırsız erişim",
  "İl bazlı fiyat takibi, favori ve fiyat alarmı",
  "Hayvan, sağlık, aşı, süt ve rasyon kayıtlarını dijital tutma",
  "İlanlarla doğrudan iletişim ve teklif verme",
];

/**
 * Girişsiz ziyaretçi bir değer işlemine (iletişim, favori, alarm) dokunduğunda
 * kayıt çağrısı gösterir. İçerik indekslenmeye devam eder; yalnız işlem anında sorar.
 */
export const useSignupGate = () => {
  const [gate, setGate] = useState(null);

  /** guard(user, reason, action) — kullanıcı varsa action çalışır, yoksa kapı açılır. */
  const guard = (user, reason, action) => {
    if (user) return action ? action() : true;
    trackEvent("SIGN_UP_GATE_SHOWN", { reason });
    setGate({ reason });
    return false;
  };

  return { gate, guard, closeGate: () => setGate(null) };
};

export const SignupGateDialog = ({ gate, onClose, title, description }) => {
  const navigate = useNavigate();
  if (!gate) return null;

  const go = (path) => {
    trackEvent("SIGN_UP_GATE_CLICKED", { reason: gate.reason, target: path });
    const next = `${window.location.pathname}${window.location.search}`;
    navigate(`${path}?next=${encodeURIComponent(next)}&kaynak=${encodeURIComponent(gate.reason)}`);
  };

  return (
    <div
      className="fixed inset-0 z-[70] flex items-end justify-center bg-black/60 p-0 sm:items-center sm:p-4"
      data-testid="signup-gate"
    >
      <div className="w-full max-w-md rounded-t-2xl border border-border bg-card p-5 sm:rounded-2xl">
        <div className="flex items-start justify-between gap-3">
          <h2 className="font-display text-xl font-extrabold text-primary">
            {title || "Ücretsiz üye olun, devamını görün"}
          </h2>
          <button onClick={onClose} data-testid="signup-gate-close"
            className="rounded-full border border-border p-1.5 text-muted-foreground">
            <X className="h-4 w-4" />
          </button>
        </div>
        <p className="mt-2 text-sm text-muted-foreground" data-testid="signup-gate-reason">
          {description
            || "Bu bilgiyi görmek ve kaydetmek için Ciftora hesabı gerekiyor. Üyelik ücretsiz, 1 dakika sürüyor."}
        </p>
        <ul className="mt-4 space-y-2 text-sm">
          {BENEFITS.map((b) => (
            <li key={b} className="flex gap-2">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-secondary" />
              <span>{b}</span>
            </li>
          ))}
        </ul>
        <button onClick={() => go("/kayit")} data-testid="signup-gate-register"
          className="mt-5 h-12 w-full rounded-full bg-primary text-sm font-bold text-primary-foreground">
          Ücretsiz üye ol
        </button>
        <button onClick={() => go("/giris")} data-testid="signup-gate-login"
          className="mt-2 h-11 w-full rounded-full border border-border text-sm font-bold text-primary">
          Hesabım var, giriş yap
        </button>
        <p className="mt-3 text-center text-[11px] text-muted-foreground">
          Telefon numaranız doğrulama için kullanılmaz, SMS göndermiyoruz.
        </p>
      </div>
    </div>
  );
};
